import React from "react";
import { IonLoading } from "@ionic/react";

const Loader = ({ isOpen = true, message }) => {
  return <IonLoading isOpen={isOpen} message={message} />;
};

export default Loader; 
